import React from 'react';
export const defaultConfig = {
    strokeWidth: 5,
    size: 50,
};
export const ProgressCircleContext = React.createContext(defaultConfig);
export const useProgressCircle = () => React.useContext(ProgressCircleContext);
